import React from 'react';
import TVODOverlayNoPortal from '../../../../components/elements/tvod/TVODOverlayNoPortal';
import { Modal } from '@intigral/ui';
import { useMediaQuery } from '@intigral/hooks';
import { Button, FlexWrapper, Text } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import QRCode from 'react-qr-code';
import { __ } from '../../../../translations';
import h from '../../../../helpers/common';
import { iTvodModal } from '../../types/iDetailOverlay';

export const TvodModal: React.FC<iTvodModal> = ({
    showTvodPurchaseOverlay,
    tvodInfo,
    item,
    openQRModal,
    setShowTvodPurchaseOverlay,
    handlePurchase,
    setOpenQRModal,
}) => {
    const isMobile = useMediaQuery('(max-width: 924px)');

    return (
        <div
            style={{
                position: 'relative',
                zIndex: 20,
            }}
        >
            <TVODOverlayNoPortal
                isOpen={showTvodPurchaseOverlay}
                onClose={() => setShowTvodPurchaseOverlay(false)}
                tvodInfo={tvodInfo}
                content={item}
                onPurchase={handlePurchase}
            />

            {openQRModal && (
                <Modal
                    open={openQRModal}
                    onOpenChange={() => setOpenQRModal(!openQRModal)}
                    closePlacement="null"
                    widthSet="medium"
                >
                    {isMobile ? (
                        <FlexWrapper flexDirection="column" justifyContent="center" gap="2x" paddingTop="3x">
                            <FlexChild alignSelf="center">
                                <div className="header-logo"></div>
                            </FlexChild>
                            <Text as="h3" variant="h5" margin="0">
                                {__('qr_code_modal_mobileview_title')}
                            </Text>
                            <Text as="p" variant="text5" color="gray">
                                {__('qr_code_modal_movileview_description')}
                            </Text>
                            <Button onClick={() => window.open(h.getOpenAppDeepLinkUrl())} fullWidth>
                                {__('open_app_button_title')}
                            </Button>
                        </FlexWrapper>
                    ) : (
                        <FlexWrapper flexDirection="column" justifyContent="center" gap="2x">
                            <FlexChild alignSelf="center">
                                <QRCode
                                    id="QRCodeScaled"
                                    size={256}
                                    style={{
                                        height: 'auto',
                                        maxWidth: '100%',
                                        width: '100%',
                                        backgroundColor: '#fff',
                                        padding: 'calc(var(--step) * 3)',
                                        borderRadius: 'var(--step)',
                                    }}
                                    value={h.getOpenAppDeepLinkUrl()}
                                    viewBox={`0 0 256 256`}
                                />
                            </FlexChild>
                            <Text as="h3" variant="h5" margin="0">
                                {__('qr_code_modal_title')}
                            </Text>
                            <Text as="p" variant="text5" color="gray">
                                {__('qr_code_modal_description')}
                            </Text>
                            <Button onClick={() => setOpenQRModal(!openQRModal)} fullWidth>
                                {__('devices_control_popup_button')}
                            </Button>
                        </FlexWrapper>
                    )}
                </Modal>
            )}
        </div>
    );
};
